import {
  createSlice,
  PayloadAction,
  // createAsyncThunk,
  // createDraftSafeSelector,
} from "@reduxjs/toolkit";
import { getUserInfo } from "store/reducers/user";
import store, { RootState } from "store";

interface IInitialState {
  noticeDetail: {
    notice_id: any,
    visible: boolean
  };
  noticeModalItem: {
    visible: boolean
    list: any[],
  }
}

const initialState: IInitialState = {
  // 消息详情弹窗
  noticeDetail: {
    notice_id: null,
    visible: false
  },
  // 消息列表弹窗
  noticeModalItem: {
    visible: false,
    list: []
  }
};

export const noticeSlice = createSlice({
  name: "notice",
  initialState: initialState,
  reducers: {
    setNoticeDetail: (state, action: PayloadAction<any>) => {
      state.noticeDetail = Object.assign({}, state.noticeDetail, action.payload);
    },
    setNoticeModalItem: (state, action: PayloadAction<any>) => {
      state.noticeModalItem = Object.assign({}, state.noticeModalItem, action.payload);
    }
  },
});

export const mapNoticeModalItem = (state: RootState) => state.notice.noticeModalItem;
export const mapNoticeDetail = (state: RootState) => state.notice.noticeDetail;
export const { setNoticeDetail, setNoticeModalItem } = noticeSlice.actions;

// 设置消息提醒弹窗
export const setNoticeModalVisible = (visible: boolean) => {
  const dispatch = store.dispatch;

  dispatch(setNoticeModalItem({
    visible: visible
  }))
  // 关闭弹窗，重新获取用户信息
  if (!visible) {
    dispatch(getUserInfo({}));
  }
};

export const setNoticeList = (list: any[]) => {
  const dispatch = store.dispatch;

  dispatch(setNoticeModalItem({
    list: list
  }))
};

export default noticeSlice.reducer;
